module.exports = __webpack_public_path__ + "img/map.bbbf10c0.jpg";